<template>
  <hl-Modal :title="systemMessage.title">
    <!-- Loader -->
    <div v-if="!systemMessage" class="text-center py-5">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!-- / Loader -->
    <div v-else>
      <div class="row border-bottom">
        <div class="col">
          <p>Til: {{ systemMessage.recipient }} &#62;</p>
          <p class="text-secondary">e-post tjeners sendings status (på engelsk): "{{ systemMessage.status }}"</p>
        </div>

        <div class="col text-right">
          <hl-Date :date="systemMessage.created" />
        </div>
      </div>

      <div class="mt-4" v-html="systemMessage.formatedText"></div>

      <div class="mt-5 not-printable">
        <button class="btn btn-outline-secondary mr-2" @click="triggerPrintDialog">Skriv ut</button>
        <button class="btn btn-outline-secondary ml-2" @click="emitClose">Lukk</button>
      </div>
    </div>
  </hl-Modal>
</template>

<script>
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';

export default {
  components: {
    'hl-Modal': Modal,
    'hl-Date': Date,
  },

  props: {
    systemMessage: Object,
  },

  methods: {
    emitClose() {
      this.$emit('close');
    },

    triggerPrintDialog() {
      window.print();
    },
  },
};
</script>

<style>
@media print {
  .small-container {
    max-width: 100% !important;
  }

  .hl-modal {
    border: none !important;
  }
  .not-printable {
    display: none;
  }
}
</style>
